import { render, staticRenderFns } from "./Divider.vue?vue&type=template&id=46fa57b1&"
import script from "./Divider.vue?vue&type=script&lang=ts&"
export * from "./Divider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports